const moneyFormatter = (number, minimumFractionDigits = 2, maximumFractionDigits = 2) => {
  if (!number) return '0.00';
  
  return Number(number).toLocaleString('en', { minimumFractionDigits, maximumFractionDigits });
}
export default moneyFormatter;